import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { TranslateFormNewComponent } from './translate-form-new/translate-form-new.component';
import { ThemeService } from 'src/app/services/theme.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateFormAiComponent } from './translate-form-ai/translate-form-ai.component';

export interface LanguageInterface {
  col: string;
  id: string;
  name: string;
}

@Component({
  selector: 'app-translate-form',
  templateUrl: './translate-form.component.html',
  styleUrl: './translate-form.component.scss',
  standalone:false
})
export class TranslateFormComponent implements OnInit, AfterViewInit {

  massChange() {

    let cnt = this.selection.selected.length ;
    if (cnt == 0) {
      this.snackBar.showError("translate.nolines.selected");
      return;
    }

    this.dialogServices.title = "actions.masschange";
    this.dialogServices.openGenericDialog(TranslateFormNewComponent,
      {
        languages:this.languages,
        massChange:true
      }, (okFunction:any)=>{
        this.dialogServices.openNewDialog("translate.masschange.confirm"+":" + this.selection.selected.length,async()=>{
        
          for (const item of this.selection.selected) {
            if ( item['INTERNALID'] != null ){
              this.languages.forEach((lang) => {
                item[lang.col] = okFunction[lang.col] == undefined ? '' : okFunction[lang.col]; 
              })
                   
              await this.saveRow(item).then((data)=>{
                this.snackBar.showSuccess("translate.edit.success"+":"+ item['ID']);
              }).catch((error)=>{
                throw new Error(error);
              })
              
            }
        
         };
         await this.loadTranslations();
        },()=>{},false);
        
        
      },()=>{},'90vh','90vw',false,null,'S','20px');
  }

  iaROW() {

    let cnt = this.selection.selected.length ;
    if (cnt == 0) {
      this.snackBar.showError("translate.nolines.selected");
      return;
    }

    this.dialogServices.openGenericDialog(TranslateFormAiComponent,
      {
        languages:this.languages,
        items:this.selection.selected
      }, async (okFunction:any)=>{
          let rows = okFunction as any[];
          await this.saveRowMutiple(okFunction).then((data)=>{
              this.snackBar.showSuccess(this.ls.instant("translate.ai.success",{count:rows.length}));
          }).catch((error)=>{
            throw new Error(error);
          })
          this.loadTranslations();
        
        
      },()=>{},'90vh','90vw',false,null,'S','20px');
    
  }
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('input') input: ElementRef;

  ngAfterViewInit() {
    
  }
  
  deleteRow() {
    let cnt = this.selection.selected.length ;
    if (cnt == 0) {
      this.snackBar.showError("translate.nolines.selected");
      return;
    }

    
      this.dialogServices.title = "translate.delete.title";
      this.dialogServices.openNewDialog(
        "Excluir os itens selecionados ( "+ cnt + " ) ?",
        () => {
             this.selection.selected.forEach(async (item) => {
      
                await this.deleteTranslations(item).then((data)=>{

                  let index = this.dataSource.data.findIndex((item1:any) => {
                    if ( item1['INTERNALID'] == item['INTERNALID'] ){
                      return true;
                    }});
                  if ( index != -1 ){
                    this.dataSource.data.splice(index, 1);
                  }
                }).catch((error)=>{
                  throw new Error('Error deleting row:' + error);
                })
              });
                this.dataSource._updateChangeSubscription(); // Update the data source to reflect changes
                this.selection.clear(); // Clear the selection after deletion
                this.snackBar.showSuccess("translate.delete.success"+":"+ cnt);
          });                

  }

  deleteTranslations(row: any):Promise<any> {
    return new Promise((resolve, reject) => {
      let ob = {
        entityName: 'Mktplanguage',
        condition: 'INTERNALID=' + row['INTERNALID'],
      }; 

      this.http.post(ob,'JsonBrokerServices/remove',false,true,false).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }


  addRow() {
    this.dialogServices.title = "Novo Registro";
    this.dialogServices.openGenericDialog(TranslateFormNewComponent,
      {
        languages:this.languages
      },(okFunction:any)=>{
        this.saveRow(okFunction).then((data)=>{
          this.loadTranslations().then(()=>{
            this.snackBar.showSuccess("translate.add.success"+":"+ data['ID']);
          });
        })
        .catch((error)=>{
          throw new Error(error);
        });
        
        
      },()=>{},'90vh','90vw',false,null,'S','20px');
    
  }


  languages: LanguageInterface[];
  displayedColumns: string[] = ['select','INTERNALID', 'ID'];
  dataSource = new MatTableDataSource([]);
  selection = new SelectionModel<{}>(true, []);
  temporaryRow=null;

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const filterValue = filter.toLowerCase().split(" ");
      const includeWord  = filterValue.find(word => !word.startsWith('-'));
      const excludeWords = filterValue.filter(word => word.startsWith('-')).map(word => word.substring(1)); 
      const dataString = JSON.stringify(data).toLowerCase();
      return (includeWord ? dataString.includes(includeWord.toLowerCase()) : true) &&
             !excludeWords.some(word => dataString.includes(word.toLowerCase()));
        

    };
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  constructor(  private http:HTTPService, 
                private ls:LanguageServices,
                private dialogServices:DialogService,
                private snackBar:SnackbarService,
                public ThemeService:ThemeService,
                private spinner:NgxSpinnerService){}
  
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource._filterData(this.dataSource.data));
  }

  checkboxLabel(row?: {}): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row['internalid'] + 1}`;
  }
  
  async ngOnInit() {
    
    if ( localStorage.getItem('languages') == null ){
      this.languages = this.ls.languages.map((item,index) => {
        return {
          col: item.id.toUpperCase().replace('-',''),
          id: item.id,
          name: item.name,
        };
      });
      localStorage.setItem('languages', JSON.stringify(this.languages)); 
    }else{
      this.languages = JSON.parse(localStorage.getItem('languages'));
    }
    

     this.languages.forEach((item) => {
        this.displayedColumns.push(item.col);
     });

     this.displayedColumns.push('actions');
     

    await this.loadTranslations();

  }



  async loadTranslations() {
    this.spinner.show('translation');
    return new Promise((resolve, reject) => {
      let ob = {
        entityName: 'Mktplanguage',
        condition:'0=0',
        rows: 99999,
      }
      
        this.http.post(ob,'JsonBrokerServices/find',false,true,false).subscribe({
          next: (data) => {
            let translations = data['Mktplanguage'].map((item: any) => {
              for (let i = 0; i < this.languages.length; i++) {
                let lang = this.languages[i];
                let languageData:object[] = JSON.parse(item['LANGUAGE']);
                let languageItem = languageData.find((langItem: any) => langItem['language'] === lang.id);  
                

                item[lang.col] = languageItem == null || languageItem['text'] == undefined ? '' : languageItem['text'];
              }
              return item;

            });
            resolve(translations);
            this.dataSource = new MatTableDataSource(translations);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.selection.clear(); 
            this.input.nativeElement.value = '';
            
          },
          error: (error) => {
            reject(error);
          },
          complete: () => {
            this.spinner.hide('translation');
          }
        });
    });
  }
  
  editRow(event,row: any, evento:string) {
    event.stopPropagation(); // Prevent the click event from propagating to the row

    
    if( evento == 'edit' ){
      row['editMode'] = true;
      this.temporaryRow = { ...row }; // Create a copy of the row to store temporary changes
      delete this.temporaryRow['editMode'];
    }else{
      row['editMode'] = false;
        this.saveRow(row).then((data)=>{
        }).catch((error)=>{
          throw error;
        });
    }
  }

  cancelEditRow(event,row: any) {
    event.stopPropagation(); // Prevent the click event from propagating to the row
    
    
    let index = this.dataSource.data.findIndex((item:any) => {
      if ( item['INTERNALID'] == row['INTERNALID'] ){
        return true;
      }});
    if ( index != -1 ){
      this.dataSource.data[index]= this.temporaryRow;
    }
    this.dataSource._updateChangeSubscription(); // Update the data source to reflect changes
    this.temporaryRow = null;
    row['editMode'] = false;
  }

  async saveRow(row: any):Promise<any> {
    
    row['LANGUAGE'] = JSON.stringify(
      
        this.languages.map((item) => {
            let newLanguage = {        
                  language: item.id,
                  text: row[item.col] == undefined ? '' : row[item.col]
                }
                return newLanguage;
              }
          )
    );
      
    if (row['editMode'] != null){
      delete row['editMode'];
    }
    if ( row['select'] != null ){
      delete row['select'];
    }
    

    return new Promise((resolve, reject) => {
      let ob = {
        entityName: 'Mktplanguage',
        CODECOMPANY: 0
      };

      if ( row['INTERNALID'] != null ){
        ob['condition']= 'INTERNALID=' + row['INTERNALID'];
      }

      
      let mergedObject = Object.assign({}, ob, row);

      this.http.post(mergedObject,'JsonBrokerServices/save',false,true,false).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }


  async saveRowMutiple(rows: any[]):Promise<any> {
    
    for ( var row of rows ){
        row['LANGUAGE'] = JSON.stringify(
          
            this.languages.map((item) => {
                let newLanguage = {        
                      language: item.id,
                      text: row[item.col] == undefined ? '' : row[item.col]
                    }
                    return newLanguage;
                  }
              )
        );
          
        if (row['editMode'] != null){
          delete row['editMode'];
        }
        if ( row['select'] != null ){
          delete row['select'];
        }
        row['CODECOMPANY'] = 0;
    }
    
    let ob = {
      entityName: 'Mktplanguage',
      data: rows
    }

    return new Promise((resolve, reject) => {
      
      this.http.post(ob,'JsonBrokerServices/save',false,true,false).subscribe({
        next: (data) => {
          resolve(data);
        },
        error: (error) => {
          reject(error);
        }
      });
    });
  }
}

